<template>
  <v-app>
    <v-content>
      <div id="app">
        <router-view/>
      </div>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'app',

  mounted () {
    let lang = 'de'
    if (this.$route.params.lang !== 'site') {
      lang = this.$route.params.lang || 'de'
    }
    this.$root.$i18n.locale = lang
  }
}
</script>

<style lang="stylus">
#app
  font-family 'Montserrat', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
html, body
  margin 0
.home
  background #090919
  height 100%
  min-height 100vh
</style>
